<template>
    <div class="page">
        <Header v-if="!noHeader" :is-crm="isCrm" :title="title" :subtitle="subtitle" @back="back">
            <template v-if="$slots['header-title']" #title>
                <slot name="header-title" />
            </template>
            <template v-if="$slots['header-center']" #center>
                <slot name="header-center" />
            </template>
            <template v-if="$slots['header-right']" #right>
                <slot name="header-right" />
            </template>
            <template v-if="$slots['header-before-idea']" #header-before-idea>
                <slot name="header-before-idea" />
            </template>
            <template v-if="$slots['header-after-support']" #header-after-support>
                <slot name="header-after-support" />
            </template>
        </Header>
        <main class="content" :class="contentClass">
            <slot />
        </main>
        <portal-target name="modals" multiple />
        <ToastList />
    </div>
</template>

<script>
import Header from '../Header';
import ToastList from '@speechki-frontend/shared/ui/ToastList';

export default {
    components: {
        ToastList,
        Header,
    },
    props: {
        title: {
            type: String,
            default: undefined,
        },
        subtitle: {
            type: String,
            default: undefined,
        },
        noHeader: {
            type: Boolean,
            default: false,
        },
        narrowContainer: {
            type: Boolean,
            default: false,
        },
        contentClass: {
            type: [String, Array, Object],
            default: '',
        },
        // temporary prop hiding docs dropdown and other editor specific components
        // until we find a better way to work with layout components
        isCrm: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        back() {
            if (this.$attrs.onBack) {
                this.$emit('back');
                return;
            }

            this.$router.back();
        },
    },
};
</script>

<style lang="scss" src="./Layout.scss"></style>
